const FETCH_BUSSINESS_LIST="FETCH_BUSSINESS_LIST";
const FETCH_BUSSINESS_CON="FETCH_BUSSINESS_CON";
const FETCH_BUSSINESS_ARTICLE="FETCH_BUSSINESS_ARTICLE";
const FETCH_BUSSINESS_ZXZX="FETCH_BUSSINESS_ZXZX";


const ActionType={
    FETCH_BUSSINESS_LIST,
    FETCH_BUSSINESS_CON,
    FETCH_BUSSINESS_ARTICLE,
    FETCH_BUSSINESS_ZXZX,
}

export default ActionType;